export const DEMO_CUENTAS = [
    {
        email: "admin@certificae.cl",
        password: "demo",
        nombre: "Ana Administradora",
        perfil: "ADMINISTRADOR",
        integradorId: null,
    },
    {
        email: "certificador@certificae.cl",
        password: "demo",
        nombre: "Denise Certificadora",
        perfil: "CERTIFICADOR",
        integradorId: null,
    },
    {
        email: "contacto@came.cl",
        password: "demo",
        nombre: "Carlos Integrador",
        perfil: "INTEGRADOR",
        integradorId: "int-came",
    },
];
export const INTEGRADORES_DEMO = [
    {
        id: "int-came",
        codigo: "CAME",
        rut: "76.123.456-7",
        razonSocial: "Came SpA",
        nombreFantasia: "Came Facturación",
        correoContacto: "contacto@came.cl",
        telefono: "+56 2 2345 6789",
        direccionFacturacion: "Av. Providencia 1200, Santiago",
        estado: "ACTIVO",
        fechaCreacion: "2025-03-12T10:00:00.000Z",
    },
    {
        id: "int-nexis",
        codigo: "NEXIS",
        rut: "77.987.654-3",
        razonSocial: "Nexis Software Ltda.",
        nombreFantasia: "Nexis",
        correoContacto: "ops@nexis.cl",
        telefono: "+56 9 8765 4321",
        direccionFacturacion: "Calle Prat 450, Valparaíso",
        estado: "ACTIVO",
        fechaCreacion: "2025-06-01T15:30:00.000Z",
    },
    {
        id: "int-orbit",
        codigo: "ORBIT",
        rut: "76.555.111-2",
        razonSocial: "Orbit Contable SpA",
        nombreFantasia: "Orbit",
        correoContacto: "hola@orbit.cl",
        telefono: "+56 2 2987 1122",
        direccionFacturacion: "Av. Apoquindo 4500, Las Condes",
        estado: "INACTIVO",
        fechaCreacion: "2024-11-20T09:15:00.000Z",
    },
];
export const USUARIOS_DEMO = [
    {
        id: "usr-admin",
        nombre: "Ana Administradora",
        email: "admin@certificae.cl",
        perfil: "ADMINISTRADOR",
        integradorId: null,
        estado: "ACTIVO",
        fechaCreacion: "2025-01-10T12:00:00.000Z",
        fechaActualizacion: "2025-01-10T12:00:00.000Z",
    },
    {
        id: "usr-cert",
        nombre: "Denise Certificadora",
        email: "certificador@certificae.cl",
        perfil: "CERTIFICADOR",
        integradorId: null,
        estado: "ACTIVO",
        fechaCreacion: "2025-01-10T12:00:00.000Z",
        fechaActualizacion: "2025-08-01T10:00:00.000Z",
    },
    {
        id: "usr-came-1",
        nombre: "Carlos Integrador",
        email: "contacto@came.cl",
        perfil: "INTEGRADOR",
        integradorId: "int-came",
        estado: "ACTIVO",
        fechaCreacion: "2025-03-15T11:00:00.000Z",
        fechaActualizacion: "2025-03-15T11:00:00.000Z",
    },
    {
        id: "usr-came-2",
        nombre: "María Operaciones",
        email: "ops@came.cl",
        perfil: "INTEGRADOR",
        integradorId: "int-came",
        estado: "ACTIVO",
        fechaCreacion: "2025-04-02T09:00:00.000Z",
        fechaActualizacion: "2025-04-02T09:00:00.000Z",
    },
    {
        id: "usr-nexis-1",
        nombre: "Pedro Nexis",
        email: "ops@nexis.cl",
        perfil: "INTEGRADOR",
        integradorId: "int-nexis",
        estado: "ACTIVO",
        fechaCreacion: "2025-06-05T16:00:00.000Z",
        fechaActualizacion: "2025-06-05T16:00:00.000Z",
    },
];
export const SOLICITUDES_DEMO = [
    {
        id: "sol-1001",
        integradorId: "int-came",
        usuarioCreadorId: "usr-came-1",
        rutEmpresa: "76.111.222-3",
        razonSocial: "Comercial Andina SpA",
        nombreFantasia: "Andina Market",
        rutRepresentante: "12.345.678-9",
        nombreRepresentante: "Laura Pérez",
        emailRepresentante: "laura@andina.cl",
        emailAdministrativo: "admin@andina.cl",
        emailRecepcion: "dte@andina.cl",
        logoDocumentosTributarios: null,
        contacto: {
            email: "contacto@andina.cl",
            telefono: "+56 2 2555 1000",
            urlWeb: "https://andina.cl",
        },
        rutTitularCertificado: "12.345.678-9",
        tieneCertificado: true,
        documentos: [
            "FACTURA_ELECTRONICA",
            "NOTA_CREDITO",
            "BOLETA_AFECTA",
            "BOLETA_EXENTA",
            "FACTURA_COMPRA",
        ],
        fechaCreacion: "2026-10-20T14:22:00.000Z",
    },
    {
        id: "sol-1002",
        integradorId: "int-nexis",
        usuarioCreadorId: "usr-cert",
        rutEmpresa: "77.444.555-6",
        razonSocial: "Exportadora Pacífico Ltda.",
        nombreFantasia: "Pacífico Export",
        rutRepresentante: "9.876.543-2",
        nombreRepresentante: "Jorge Muñoz",
        emailRepresentante: "jorge@pacifico.cl",
        emailAdministrativo: "finanzas@pacifico.cl",
        emailRecepcion: "recepcion@pacifico.cl",
        logoDocumentosTributarios: null,
        contacto: {
            email: "ops@pacifico.cl",
            telefono: "+56 32 211 3344",
            urlWeb: "https://pacifico.cl",
        },
        rutTitularCertificado: "9.876.543-2",
        tieneCertificado: true,
        documentos: ["FACTURA_EXPORTACION", "FACTURA_ELECTRONICA"],
        fechaCreacion: "2026-10-28T09:40:00.000Z",
    },
    {
        id: "sol-1003",
        integradorId: "int-came",
        usuarioCreadorId: "usr-came-2",
        rutEmpresa: "76.333.888-1",
        razonSocial: "Servicios Cordillera SpA",
        nombreFantasia: "Cordillera Soft",
        rutRepresentante: "15.111.222-3",
        nombreRepresentante: "Andrea Soto",
        emailRepresentante: "andrea@cordillera.cl",
        emailAdministrativo: "admin@cordillera.cl",
        emailRecepcion: "dte@cordillera.cl",
        logoDocumentosTributarios: null,
        contacto: {
            email: "hola@cordillera.cl",
            telefono: "+56 9 7000 1122",
            urlWeb: "",
        },
        rutTitularCertificado: "15.111.222-3",
        tieneCertificado: true,
        documentos: ["LIQUIDACION_FACTURA"],
        fechaCreacion: "2026-11-01T18:05:00.000Z",
    },
];
const etapasBasico = [
    {
        id: "et-bas-1",
        orden: 1,
        nombre: "Ejemplos",
        descripcion: "Genera XML, firma, envía al SII y obtiene Track ID.",
        estado: "COMPLETADA",
        requiereGestionManual: true,
    },
    {
        id: "et-bas-2",
        orden: 2,
        nombre: "Simulación",
        descripcion: "Ejecuta simulación y recupera respuestas del SII.",
        estado: "ESPERANDO_GESTION",
        requiereGestionManual: true,
    },
    {
        id: "et-bas-3",
        orden: 3,
        nombre: "Impresos",
        descripcion: "Genera PDF y archivos de respaldo.",
        estado: "PENDIENTE",
        requiereGestionManual: false,
    },
];
export const CERTIFICACIONES_DEMO = [
    {
        id: "cer-2001",
        solicitudId: "sol-1001",
        integradorId: "int-came",
        familia: "BASICO",
        documentos: ["FACTURA_ELECTRONICA", "NOTA_CREDITO"],
        estado: "ESPERANDO_GESTION_SII",
        etapaActual: "Simulación",
        fechaCreacion: "2026-10-20T14:22:00.000Z",
        fechaFinalizacion: null,
        tieneSetPruebas: true,
        nombreSetPruebas: "set_basico_andina.zip",
        etapas: [...etapasBasico],
        ejecuciones: [
            {
                id: "ej-1",
                etapaId: "et-bas-1",
                usuarioId: "usr-cert",
                usuarioNombre: "Denise Certificadora",
                fechaInicio: "2026-10-21T10:00:00.000Z",
                fechaFin: "2026-10-21T10:02:15.000Z",
                estado: "OK",
                mensaje: "Ejemplos enviados correctamente.",
                resultados: [
                    {
                        id: "res-1",
                        tipo: "TRACK_ID",
                        nombre: "Track ID envío ejemplos",
                        trackId: "8123456789",
                        fechaGeneracion: "2026-10-21T10:02:10.000Z",
                    },
                    {
                        id: "res-2",
                        tipo: "XML",
                        nombre: "envio_ejemplos.xml",
                        fechaGeneracion: "2026-10-21T10:01:40.000Z",
                    },
                ],
            },
            {
                id: "ej-2",
                etapaId: "et-bas-2",
                usuarioId: "usr-cert",
                usuarioNombre: "Denise Certificadora",
                fechaInicio: "2026-10-22T11:30:00.000Z",
                fechaFin: "2026-10-22T11:31:20.000Z",
                estado: "OK",
                mensaje: "Simulación completada. Pendiente gestión en portal SII.",
                resultados: [
                    {
                        id: "res-3",
                        tipo: "TRACK_ID",
                        nombre: "Track ID simulación",
                        trackId: "8987654321",
                        fechaGeneracion: "2026-10-22T11:31:15.000Z",
                    },
                ],
            },
        ],
    },
    {
        id: "cer-2002",
        solicitudId: "sol-1001",
        integradorId: "int-came",
        familia: "BOLETAS",
        documentos: ["BOLETA_AFECTA", "BOLETA_EXENTA"],
        estado: "PENDIENTE",
        etapaActual: "Carga de set",
        fechaCreacion: "2026-10-20T14:22:00.000Z",
        fechaFinalizacion: null,
        tieneSetPruebas: false,
        nombreSetPruebas: null,
        etapas: [
            {
                id: "et-bol-1",
                orden: 1,
                nombre: "Procesamiento boletas",
                descripcion: "Procesa el set de boletas y genera resultados.",
                estado: "PENDIENTE",
                requiereGestionManual: true,
            },
        ],
        ejecuciones: [],
    },
    {
        id: "cer-2003",
        solicitudId: "sol-1001",
        integradorId: "int-came",
        familia: "COMPRA",
        documentos: ["FACTURA_COMPRA"],
        estado: "FINALIZADA",
        etapaActual: "Cierre",
        fechaCreacion: "2026-10-20T14:22:00.000Z",
        fechaFinalizacion: "2026-10-25T16:40:00.000Z",
        tieneSetPruebas: true,
        nombreSetPruebas: "set_compra_andina.zip",
        etapas: [
            {
                id: "et-com-1",
                orden: 1,
                nombre: "Procesamiento compra",
                descripcion: "Ejecuta el set de factura de compra.",
                estado: "COMPLETADA",
                requiereGestionManual: true,
            },
        ],
        ejecuciones: [
            {
                id: "ej-3",
                etapaId: "et-com-1",
                usuarioId: "usr-cert",
                usuarioNombre: "Denise Certificadora",
                fechaInicio: "2026-10-24T09:00:00.000Z",
                fechaFin: "2026-10-24T09:01:50.000Z",
                estado: "OK",
                mensaje: "Compra certificada.",
                resultados: [
                    {
                        id: "res-4",
                        tipo: "PDF",
                        nombre: "resultado_compra.pdf",
                        fechaGeneracion: "2026-10-24T09:01:45.000Z",
                    },
                ],
            },
        ],
    },
    {
        id: "cer-2004",
        solicitudId: "sol-1002",
        integradorId: "int-nexis",
        familia: "EXPORTACION",
        documentos: ["FACTURA_EXPORTACION"],
        estado: "EN_PROCESO",
        etapaActual: "Ejemplos",
        fechaCreacion: "2026-10-28T09:40:00.000Z",
        fechaFinalizacion: null,
        tieneSetPruebas: true,
        nombreSetPruebas: "set_export_pacifico.zip",
        etapas: [
            {
                id: "et-exp-1",
                orden: 1,
                nombre: "Ejemplos",
                descripcion: "Procesa set de exportación.",
                estado: "EN_CURSO",
                requiereGestionManual: true,
            },
            {
                id: "et-exp-2",
                orden: 2,
                nombre: "Simulación",
                descripcion: "Simulación de exportación.",
                estado: "PENDIENTE",
                requiereGestionManual: true,
            },
        ],
        ejecuciones: [
            {
                id: "ej-4",
                etapaId: "et-exp-1",
                usuarioId: "usr-cert",
                usuarioNombre: "Denise Certificadora",
                fechaInicio: "2026-11-03T08:15:00.000Z",
                fechaFin: null,
                estado: "EN_CURSO",
                mensaje: "Ejecución en curso…",
                resultados: [],
            },
        ],
    },
    {
        id: "cer-2005",
        solicitudId: "sol-1002",
        integradorId: "int-nexis",
        familia: "BASICO",
        documentos: ["FACTURA_ELECTRONICA"],
        estado: "ERROR",
        etapaActual: "Ejemplos",
        fechaCreacion: "2026-10-28T09:40:00.000Z",
        fechaFinalizacion: null,
        tieneSetPruebas: true,
        nombreSetPruebas: "set_basico_pacifico.zip",
        etapas: [
            {
                id: "et-bas2-1",
                orden: 1,
                nombre: "Ejemplos",
                descripcion: "Procesa set básico.",
                estado: "ERROR",
                requiereGestionManual: true,
            },
        ],
        ejecuciones: [
            {
                id: "ej-5",
                etapaId: "et-bas2-1",
                usuarioId: "usr-cert",
                usuarioNombre: "Denise Certificadora",
                fechaInicio: "2026-11-02T17:00:00.000Z",
                fechaFin: "2026-11-02T17:00:45.000Z",
                estado: "ERROR",
                mensaje: "Error al firmar XML (mock): certificado no válido en ambiente demo.",
                resultados: [],
            },
        ],
    },
    {
        id: "cer-2006",
        solicitudId: "sol-1003",
        integradorId: "int-came",
        familia: "LIQUIDACION",
        documentos: ["LIQUIDACION_FACTURA"],
        estado: "PENDIENTE",
        etapaActual: "Carga de set",
        fechaCreacion: "2026-11-01T18:05:00.000Z",
        fechaFinalizacion: null,
        tieneSetPruebas: false,
        nombreSetPruebas: null,
        etapas: [
            {
                id: "et-liq-1",
                orden: 1,
                nombre: "Procesamiento liquidación",
                descripcion: "Procesa set de liquidación de factura.",
                estado: "PENDIENTE",
                requiereGestionManual: true,
            },
        ],
        ejecuciones: [],
    },
];
